module.exports = __webpack_public_path__ + "img/15CKmRsF1WWoixjBowfNaOZnvQcB-7PWR.20f38177.jpg";